import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEraserSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconEraserSimple"><Path d="M13.7197 2.21967C14.0126 1.92678 14.4874 1.92678 14.7803 2.21967L21.7803 9.21967C22.0732 9.51256 22.0732 9.98744 21.7803 10.2803L14.5607 17.5L6.5 9.43934L13.7197 2.21967Z" fill="currentColor"/><Path d="M5.43934 10.5L2.21967 13.7197C1.92678 14.0126 1.92678 14.4874 2.21967 14.7803L9.21967 21.7803C9.51256 22.0732 9.98744 22.0732 10.2803 21.7803L13.5 18.5607L5.43934 10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconEraserSimple;
